import { Grid, GridItem, Text, theme, useMediaQuery } from '@everlywell/ui-kit';
import NavigationTile, { NavigationTileProps } from 'components/NavigationTile';
import Container from 'components/PageSections/components/SectionContainer';
import { useFlags } from 'gatsby-plugin-launchdarkly';
import React from 'react';

import StickyAnchors from './StickyAnchors';

// Styles ----------
const paddingY = ['6', null, '10'];

export type TileProps = Omit<NavigationTileProps, 'children'> & {
  /**
   * Optional flag to show the component only on mobile
   * @default false
   */
  mobileOnly?: boolean;
  title?: string;
};

// Takes in account the navbar as well as the sticky navigation heights
export const MOBILE_NAV_BAR_HEIGHT = 73;
export const DESKTOP_NAV_BAR_HEIGHT = 89;
export const TOP_SCROLL_OFFSET = MOBILE_NAV_BAR_HEIGHT + 65;

export interface NavigationAnchorProps {
  tiles: TileProps[];
  id: string;
}

const NavigationAnchor: React.FC<NavigationAnchorProps | null> = (props) => {
  const flags = useFlags();
  const stickyNavFlag = flags.stickyNav ?? false;

  const [isMobile] = useMediaQuery(`(max-width: ${theme.breakpoints.tablet})`);

  if (!props) {
    return null;
  }

  const { tiles, id } = props;
  const isDesktop = !isMobile;

  return (
    <>
      <Container
        id={id}
        size={['sm', null, 'xl']}
        paddingTop={paddingY}
        paddingBottom={paddingY}
      >
        <Grid
          display="grid"
          gridTemplateColumns={[
            'repeat(2, 1fr)',
            'repeat(auto-fit, minmax(260px, 1fr))',
          ]}
          spacing="2"
        >
          {tiles.map(
            (tile, index) =>
              ((isDesktop && !tile.mobileOnly) || isMobile) && (
                <GridItem key={`tile-${index}`}>
                  <NavigationTile {...tile}>
                    <Text
                      as="h3"
                      fontSize={'md'}
                      fontWeight="medium"
                      color={theme.colors.tints.black}
                    >
                      {tile.title}
                    </Text>
                  </NavigationTile>
                </GridItem>
              ),
          )}
        </Grid>
      </Container>
      {stickyNavFlag && <StickyAnchors {...props} />}
    </>
  );
};

export default NavigationAnchor;
